import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `docker`,

  name: {
    [LOCALES.EN_US]: `Docker`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.tool, TYPES.runtime_environment],

  tags: [],
} as const satisfies TTerm
